module.exports = __webpack_public_path__ + "static/media/buildings.72c0ad0d.png";